import { Link } from 'react-router-dom';
import { FiLoader } from 'react-icons/fi';
import EvmBlockDetailsView from './EvmBlockDetailsView';
import PrcBlockDetailsView from './PrcBlockDetailsView';
import SolanaBlockDetailsView from './SolanaBlockDetailsView';
import TronBlockDetailsView from './TronBlockDetailsView';
import { useResolvedBlock } from '../hooks/useResolvedBlock';

function BlockResolverView({ query }) {
  const { resolved, loading, error } = useResolvedBlock(query);

  if (loading) {
    return (
      <main className="sections eth-tx-page">
        <div className="lookup-page__loading" aria-busy="true">
          <FiLoader className="explorer-spinner" aria-hidden />
          <span>Detecting chain for block {query}…</span>
        </div>
      </main>
    );
  }

  if (error || !resolved) {
    return (
      <main className="sections eth-tx-page">
        <h1 className="eth-tx-page-title">Block Details</h1>
        <div className="stx-error">
          <p>{error || 'Block not found.'}</p>
          <Link to="/" className="eth-tx-link">
            Back to home
          </Link>
        </div>
      </main>
    );
  }

  const chain = resolved.chain;
  const number = resolved.query || query;

  if (chain === 'ethereum' || chain === 'polygon') {
    return <EvmBlockDetailsView number={number} chain={chain} />;
  }

  if (chain === 'tron') {
    return <TronBlockDetailsView number={number} />;
  }

  if (chain === 'solana') {
    return <SolanaBlockDetailsView slot={number} />;
  }

  if (chain === 'prc') {
    return <PrcBlockDetailsView number={number} />;
  }

  return (
    <main className="sections eth-tx-page">
      <div className="stx-error">
        <p>Unsupported chain: {chain}</p>
        <Link to="/" className="eth-tx-link">Back to home</Link>
      </div>
    </main>
  );
}

export default BlockResolverView;
